/**
 * uiv is Vue 3 native except for Tabs' array watcher: Tab children register themselves by
 * pushing into their parent's `tabs` array, while the watcher is declared without `deep`.
 * Vue 2 noticed that mutation implicitly; Vue 3 requires the dependency to be explicit.
 */
import * as uiv from 'uiv';

const tabsWatcher = uiv.Tabs.watch.tabs;

// Keep this safe when webpack hot reload evaluates the wrapper again against the same
// module object.
if (typeof tabsWatcher === 'function') {
    uiv.Tabs.watch.tabs = {
        handler: tabsWatcher,
        deep: true,
    };
}

export default uiv;
